export function CircularProgress({
  size = "md",
  strokeWidth,
  progress = 0,
  rotate = -90,
}: {
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl"
  strokeWidth?: number
  progress?: number
  rotate?: number
}) {
  const sizes = {
    xs: 48,
    sm: 72,
    md: 128,
    lg: 192,
    xl: 256,
    xxl: 272,
  }

  const selectedSize = sizes[size]
  const defaultStrokeWidth = selectedSize * 0.1 // 10% del tamaño para más grosor
  const finalStrokeWidth = strokeWidth || defaultStrokeWidth

  const center = selectedSize / 2
  const radius = (selectedSize - finalStrokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const offset = circumference * (1 - progress / 100)

  return (
    <svg width={selectedSize} height={selectedSize}>
      <g style={{ transform: `rotate(${rotate}deg)`, transformOrigin: `${center}px ${center}px` }}>
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke="#D1D5DB"
          strokeWidth={finalStrokeWidth}
          fill="none"
          strokeLinecap="round"
        />
        <circle
          cx={center}
          cy={center}
          r={radius}
          strokeWidth={finalStrokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className="stroke-primary-500 transition-all duration-1000 ease-out"
        />
      </g>
      <text
        x={center}
        y={center}
        textAnchor="middle"
        dy=".3em"
        fontSize={selectedSize * 0.2}
        fill="#111827"
        className="font-bold leading-[27px] tracking-[-0.05em]"
      >
        {`${Math.round(progress)}%`}
      </text>
    </svg>
  )
}
